module.exports = __webpack_public_path__ + "img/43.8112751e.jpg";